import { yupResolver } from '@hookform/resolvers/yup';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetMerchantQuery } from 'api/client-domain/client-domain';
import { useQueryWithForm } from 'hooks/rtkq.hooks';
import { useForm } from 'react-hook-form';
import {
  createWorkspaceSchema,
  workspaceSchema,
} from './workspace-form.schema';

export const useWorkspaceForm = (merchantId?: string) => {
  const query = useGetMerchantQuery(merchantId ?? skipToken);

  const form = useForm({
    resolver: yupResolver(workspaceSchema),
    defaultValues: workspaceSchema.cast(query.data ?? {}, {}),
  });

  useQueryWithForm(form, query, workspaceSchema);

  return { form, query };
};

export const useCreateWorkspaceForm = () => {
  const form = useForm({
    resolver: yupResolver(createWorkspaceSchema),
    defaultValues: createWorkspaceSchema.cast({}),
  });

  return { form };
};
